import config from "@/config";

export function getClientId(hostname) {
  if (!hostname) hostname = window.location.hostname;

  if (
    hostname === "localhost" ||
    hostname === "0.0.0.0" ||
    hostname === "127.0.0.1"
  ) {
    return "test";
  }

  const parts = hostname.split(".");
  while (parts.length > 3) {
    parts.shift();
  }
  return parts[0];
}

export default function makeOAuthToken(clientId) {
  //const clientId = getClientId(window.location.hostname);
  const oauthToken = btoa(`${clientId}:${config.oauthClientSecret}`);
  return oauthToken;
}
